// removed by extract-text-webpack-plugin
module.exports = {"readOnly":"c-DeliveryOptions__readOnly","shippingName":"c-DeliveryOptions__shippingName","shippingPrice":"c-DeliveryOptions__shippingPrice","button":"c-DeliveryOptions__button"};